<div class="login">
    <h1 class="sr-only">{{ 'Login' | translate }}</h1>
    <div class="login__content">
        <core-brand-logo [isNotLink]="true"></core-brand-logo>
        <div class="login__wrapper">
            <core-dark-mode-toggle class="float-end" [moonDark]="true"></core-dark-mode-toggle>

            <a
                [core-analytics]="{ action: 'Back to login', category: 'LOGIN' }"
                class="login__goback"
                routerLink="/login">
                <svg class="login__goback-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129">
                    <path
                        d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z" />
                </svg>
                {{ 'Go back' | translate }}
            </a>

            <h2>{{ 'Login Help & FAQs' | translate }}</h2>
            <p class="login__paragraph">{{ 'We are here to help...' | translate }}</p>
        </div>

        <core-login-footer></core-login-footer>
    </div>

    <core-demo-config-toggle></core-demo-config-toggle>
</div>
